import styled from 'styled-components'

// BRAND-9514: shared pill-shaped control for the vibe-check bulk-select UI.
// Both the enter-selection button (AgentSourcedCreatorListView) and the
// selection-bar action buttons (VibeCheckSelectionMode) build on this so the
// two identical definitions can't drift.
export const PillButton = styled.button`
  appearance: none;
  border: solid 1px ${({ theme }) => theme.grey400Color};
  background: ${({ theme }) => theme.whiteColor};
  border-radius: 1rem;
  padding: 0.375rem 1rem;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.grey900Color};
  cursor: pointer;
  white-space: nowrap;
`
